import { gql } from "@apollo/client";

export const SEARCH_BRANCHES = gql`
  query ($operatorId: ID!, $partnerBranchId: ID) {
    searchBranches(operatorId: $operatorId, partnerBranchId: $partnerBranchId) {
      branchLevel
      partner {
        partnerId
      }
      partnerBranchId
      partnerBranch
      address
      contactPerson
      contactPerson2
      contactPosition
      contactPosition2
      landline
      landline2
      mobile
      mobile2
      email
      email2
      zipCode
      remarks
      branchStatus
      statusComments
      loadBalance
    }
  }
`;

export const GET_HEAD_OFFICE_BY_PARTNER_ID = gql`
  query ($partnerId: ID!) {
    getHeadOfficeByPartnerId(partnerId: $partnerId) {
      branchLevel
      partner {
        partnerId
      }
      partnerBranchId
      partnerBranch
      address
      contactPerson
      contactPerson2
      contactPosition
      contactPosition2
      landline
      landline2
      mobile
      mobile2
      email
      email2
      zipCode
      remarks
      branchStatus
      statusComments
      loadBalance
    }
  }
`;

export const UPDATE_BRANCHES = gql`
  mutation ($branches: [UpdatePartnerBranchObject]) {
    updatePartnerBranch(branches: $branches) {
      partnerBranch {
        branchLevel
        partner {
          partnerId
        }
        partnerBranchId
        partnerBranch
        address
        contactPerson
        contactPerson2
        contactPosition
        contactPosition2
        landline
        landline2
        mobile
        mobile2
        email
        email2
        zipCode
        remarks
        branchStatus
        statusComments
        loadBalance
      }
    }
  }
`;

export const CREATE_BRANCH = gql`
  mutation ($branches: [CreatePartnerBranchObject]) {
    createBranch(branches: $branches) {
      partnerBranch {
        partnerBranchId
      }
    }
  }
`;
